import { render, staticRenderFns } from "./EpsImportLeadForm.vue?vue&type=template&id=8c5cb1c4&"
import script from "./EpsImportLeadForm.vue?vue&type=script&lang=js&"
export * from "./EpsImportLeadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports